import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import ProductCard7 from './ProductCard7';
import { Span } from './Typography';
import FlexBox from './FlexBox';
import { Link } from 'react-router-dom';
import RadioButtonsGroup from './RadioButtonsGroup';
import { Box, Button, Card, Divider, Typography } from '@mui/material';
import { GlobalContext } from '../context/GlobalState';
import { useContext } from 'react';
import { strings } from 'localisation';
import { routerUrls } from 'constants';
import PriceStack from './PriceStack';
import createGAevent from 'helpers';
import { Helmet } from 'react-helmet';
import { cartLineKey } from '../utils/cartUtils';

const BOTTOM_CTA_MIN_ITEMS = 4;

export default function Cart() {
  const { cartList, shippingOption, deliveryOptions, lang } = useContext(GlobalContext);

  const getTotalPrice = () => {
    return (
      cartList.reduce(
        (accumulator, item) => accumulator + parseFloat(item.price) * item.quantity,
        0
      ) || 0
    );
  };

  const checkoutNow = () => {
    createGAevent('Cart', 'CHECKOUT_NOW_EVENT', 'total-' + getTotalPrice());
    createGAevent('Cart', `CHECKOUT_NOW_total-${getTotalPrice()}`, 'total-' + getTotalPrice());

    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'InitiateCheckout');
    } else {
      console.warn('fbq not available in InitiateCheckout');
    }
  };

  return (
    <>
      <Helmet>
        <title>Кошница</title>
        <meta name="robots" content="noindex, follow" />
        <meta name="description" content="кошница за поръчка" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Container style={{ backgroundColor: '', paddingTop: 10, justify: 'center', padding: 10 }}>
        <Typography variant="h4" color="text.primary" paddingBottom="10px">
          Количка:
        </Typography>
        <Grid container spacing={3}>
          <Grid item lg={8} md={8} xs={12}>
            {cartList.map((item) => (
              <ProductCard7 key={cartLineKey(item)} item={item} />
            ))}
          </Grid>

          <Grid item lg={4} md={4} xs={12}>
            <Card
              sx={{
                padding: '1.5rem 1.75rem',
                '@media only screen and (max-width: 678px)': {
                  padding: '1rem'
                }
              }}>
              <FlexBox
                justifyContent="space-between"
                alignItems="flex-start"
                mb={2}
                sx={{ flexDirection: { xs: 'column', sm: 'row' }, rowGap: 0.5 }}>
                <Span color="text.primary">{strings[lang].subtotal}</Span>
                <PriceStack amount={getTotalPrice()} size="md" inline />
              </FlexBox>
              <Divider
                sx={{
                  mb: '1rem'
                }}
              />
              {/* <TextField label="Voucher" placeholder="Voucher" size="small" variant="outlined" fullWidth />
            <Button variant="outlined" color="primary" fullWidth sx={{}}>Apply Voucher</Button> */}
              <Span fontWeight="600" mb={2} display="block" color="text.primary">
                {strings[lang].shipping}
              </Span>
              <RadioButtonsGroup values={deliveryOptions} />
              <Divider sx={{ mb: '1rem' }} />
              <FlexBox
                justifyContent="space-between"
                alignItems="flex-start"
                mb={2.5}
                sx={{ flexDirection: { xs: 'column', sm: 'row' }, rowGap: 0.5 }}>
                <Span fontSize="18px" fontWeight="600" color="text.primary">
                  {strings[lang].total}
                </Span>
                <PriceStack
                  amount={getTotalPrice() + parseFloat(shippingOption.price_eur || 0)}
                  size="lg"
                  inline
                />
              </FlexBox>

              <Link to={routerUrls.checkout}>
                <Button variant="contained" color="primary" fullWidth onClick={checkoutNow}>
                  {strings[lang].checkoutNow}
                </Button>
              </Link>
            </Card>
          </Grid>
        </Grid>

        {/* Second checkout CTA at the foot of the page - desktop only. On desktop the summary
            card's button sits up in the right column, so after scrolling a long cart there is
            nothing to click at the bottom. On mobile the summary card already stacks to the foot
            of the page with its own button, so this would just be a duplicate. Only worth showing
            once the cart is long enough to push the summary card's button out of view. */}
        {cartList.length > BOTTOM_CTA_MIN_ITEMS && (
          <Box
            sx={{
              mt: 5,
              pt: 3,
              borderTop: '1px solid',
              borderColor: 'divider',
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center'
            }}>
            <Button
              component={Link}
              to={routerUrls.checkout}
              variant="contained"
              color="primary"
              onClick={checkoutNow}
              sx={{ width: { xs: '100%', md: 'auto' }, minWidth: { md: 320 } }}>
              {strings[lang].checkoutNow}
            </Button>
          </Box>
        )}
      </Container>
    </>
  );
}
